module.exports = __webpack_public_path__ + "static/media/logo-cyber-light.60217993.svg";